import { Get, Post } from "@repo/helpers";

export class BaseController {
	static GetFn(controller: string) {
		return function <T>(action: string, params: object | string = {}): Promise<T> {
			return Get<T>(controller, action, params);
		};
	}

	static PostFn(controller: string) {
		return function <T>(action: string, params: object | string = {}, data?: object): Promise<T> {
			return Post<T>(controller, action, params, data);
		};
	}
}
